export interface NotificationProviderStatusApiResource {
  channel: string;
  provider_kind: string | null;
  is_configured: boolean;
  is_enabled: boolean;
  uses_platform_default: boolean;
  from_name: string | null;
  from_address: string | null;
  account_sid_suffix: string | null;
  sender_number: string | null;
  messaging_service_sid: string | null;
}

export interface NotificationProvidersApiResource {
  providers: NotificationProviderStatusApiResource[];
}

export interface NotificationProviderStatus {
  channel: string;
  providerKind: string | null;
  isConfigured: boolean;
  isEnabled: boolean;
  usesPlatformDefault: boolean;
  fromName: string | null;
  fromAddress: string | null;
  accountSidSuffix: string | null;
  senderNumber: string | null;
  messagingServiceSid: string | null;
}

export interface NotificationProviders {
  providers: NotificationProviderStatus[];
}

export interface EmailProviderConfiguration {
  host: string;
  port: number;
  username: string;
  password: string;
  useTls: boolean;
  fromName: string;
  fromAddress: string;
}

export interface SmsProviderConfiguration {
  accountSid: string;
  apiKeySid: string;
  apiKeySecret: string;
  fromNumber: string;
  messagingServiceSid: string;
}

export interface ProviderTestResult {
  delivered: boolean;
}

export type SmsTestOutcome = 'delivered' | 'pending' | 'failed' | 'not_configured';

export type SmsFailureReason =
  | 'invalid_credentials'
  | 'sending_not_permitted'
  | 'destination_not_permitted'
  | 'invalid_recipient'
  | 'invalid_sender'
  | 'recipient_opted_out'
  | 'carrier_rejected'
  | 'provider_unavailable'
  | 'unknown';

export interface SmsProviderTestResultApiResource {
  outcome: SmsTestOutcome;
  failure_reason: SmsFailureReason | null;
  provider_error_code: number | null;
}

export interface SmsProviderTestResult {
  outcome: SmsTestOutcome;
  failureReason: SmsFailureReason | null;
  providerErrorCode: number | null;
}

export function mapApiResourceToSmsProviderTestResult(
  resource: SmsProviderTestResultApiResource
): SmsProviderTestResult {
  return {
    outcome: resource.outcome,
    failureReason: resource.failure_reason,
    providerErrorCode: resource.provider_error_code,
  };
}

export function mapApiResourceToNotificationProviders(
  resource: NotificationProvidersApiResource
): NotificationProviders {
  return {
    providers: resource.providers.map(function mapProvider(provider) {
      return {
        channel: provider.channel,
        providerKind: provider.provider_kind,
        isConfigured: provider.is_configured,
        isEnabled: provider.is_enabled,
        usesPlatformDefault: provider.uses_platform_default,
        fromName: provider.from_name,
        fromAddress: provider.from_address,
        accountSidSuffix: provider.account_sid_suffix,
        senderNumber: provider.sender_number,
        messagingServiceSid: provider.messaging_service_sid,
      };
    }),
  };
}
